import React, { useEffect, useRef, useState } from 'react';
import classNames from 'classnames';
import { Calendar } from 'react-multi-date-picker';
import moment from 'moment';
import Dropdown from '../../base/Dropdown/Dropdown';
import TextInput from '../TextInput/TextInput';
import gregorian_ru from '../RangeDatePicker/gregorian_ru';
import { Icons } from '../../base/BootstrapComponents/BootstrapComponents';
import '../RangeDatePicker/RangeDatePickerStyles.scss';

const defaultDateFormat = 'DD.MM.YYYY';

export default function DatePicker(props) {
  const {
    className = '',
    disabled = false,
    inputProps = {},
    withLabel = false,
    usePortal = true,
    inline = false,
    fieldState = {
      error: '',
      touched: false,
    },
    disableInitialSelect = false,
    notDefaultValue = false,
    withFormat = null,
    changeFormat = null,
    variant = null,
    onChangeToIso = false,
  } = props;

  const { onChange = () => {}, name, value } = inputProps;
  const { error = '', touched = false } = fieldState;
  const pickerRef = useRef(null);
  const anchorElement = useRef(null);
  const [currentValue, setCurrent] = useState(value);
  const [pickerKey, setPickerKey] = useState(0);
  const format = withFormat || defaultDateFormat;
  let cvm = changeFormat ? moment(currentValue, changeFormat) : moment(currentValue);
  if (!cvm.isValid()) {
    cvm = null;
  }

  useEffect(() => {
    setCurrent(value);
  }, [value]);

  const onSelect = (newValue, initialSelect) => {
    if (!inputProps) {
      return;
    }
    if (initialSelect && (disableInitialSelect || notDefaultValue)) {
      return;
    }
    const date = newValue && newValue.isValid ? newValue.toDate() : null;
    const selected = date ? date.toString() : '';
    const newMoment = moment(date);
    if (changeFormat) {
      setCurrent(newMoment.format(changeFormat));
    } else {
      setCurrent(selected);
    }

    if (changeFormat) {
      onChange({ target: { value: newMoment.format(changeFormat), name } });
    } else if (onChangeToIso) {
      onChange({ target: { value: date ? date.toISOString() : '', name } });
    } else {
      onChange({ target: { value: selected, name } });
    }
    setTimeout(() => {
      setPickerKey(pickerKey + 1);
    }, 50);
  };

  const onReset = event => {
    setCurrent('');
    onChange({ target: { value: '', name } });
    event.stopPropagation();
  };

  return (
    <div className={classNames('form-control-wrapper date-picker', { 'inline-picker': inline }, className)}>
      <div className="custom-react-date-picker">
        <Dropdown usePortal={usePortal} disabled={disabled}>
          <Dropdown.Toggle className="mini-profile-button">
            <div ref={anchorElement} className="date-selector-wrapper">
              <div className="date-selector">
                <TextInput
                  {...props}
                  readOnly
                  className={classNames('data-picker-text', { 'is-invalid': error && touched })}
                  containerRef={pickerRef}
                  inputProps={{
                    value: cvm ? cvm.format(format) : '',
                  }}
                  withLabel={withLabel}
                  inputAfter={(
                    <div className="search-wrapper">
                      <Icons customIcon className="search" width={21} height={24} icon="calendar" />
                      <Icons customIcon onClick={onReset} width={24} height={24} icon="close" />
                    </div>
                  )}
                  variant={variant}
                />
              </div>
            </div>
          </Dropdown.Toggle>
          <Dropdown.Menu anchorElement={anchorElement} disableClickToggle className="data-picker-wrapper" useResizeContent={false}>
            <Calendar
              key={pickerKey}
              locale={gregorian_ru}
              weekStartDayIndex={1}
              onChange={onSelect}
              value={cvm ? cvm.toDate() : new Date()}
            />
          </Dropdown.Menu>
        </Dropdown>
      </div>
    </div>
  );
}
